import { render } from "./TraineeReportsHTML.vue?vue&type=template&id=886883bc&scoped=true"
import script from "./TraineeReportsHTML.vue?vue&type=script&lang=js"
export * from "./TraineeReportsHTML.vue?vue&type=script&lang=js"

import "./TraineeReportsHTML.vue?vue&type=style&index=0&id=886883bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-886883bc"]])

export default __exports__